import React, { useState, useEffect } from "react";
import axios from "axios";
import "./SavedSearchesEditor.css";
import { globals } from '../globals';

export default function SavedSearchEditor() {
  const [searches, setSearches] = useState([]);
  const [editing, setEditing] = useState(null);

  useEffect(() => {
    fetchSearches();
  }, []);

  const fetchSearches = async () => {
    try {
      const response = await axios.get(`${globals.homepageUrl}/php/get-saved-searches.php`);
      setSearches(response.data.savedSearches);
    } catch (err) {
      console.error("Errore nel caricamento delle ricerche:", err);
      setSearches([]);
    }
  };

  const handleChange = (id, field, value) => {
    setSearches((prev) =>
      prev.map((search) =>
        search.id === id ? { ...search, [field]: value } : search
      )
    );
  };

  const handleSave = async (search) => {
    try {
      await axios.post(`${globals.homepageUrl}/php/update-saved-searches.php`, search);
      setEditing(null);
      fetchSearches(); // ricarica per sicurezza
    } catch (err) {
      alert("Errore nel salvataggio");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Sei sicuro di voler cancellare questa ricerca salvata?")) return;

    try {
      const response = await axios.post(`${globals.homepageUrl}/php/delete-saved-search.php`, { id });
      if (response.data.success) {
        setSearches((prev) => prev.filter((s) => s.id !== id));
      } else {
        alert("Errore durante la cancellazione: " + (response.data.error || "Unknown error"));
      }
    } catch (err) {
      alert("Errore di rete o server durante la cancellazione");
    }
  };

  return (
    <div className="savedsearches-editor-container">
      <h2>Saved Searches Editor</h2>
      <table className="savedsearches-editor-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Query</th>
            <th>Label</th>
            <th>Weight</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {searches.map((search) => (
            <tr key={search.id}>
              <td>{search.id}</td>
              <td>
                {editing === search.id ? (
                  <textarea
                    className="savedsearches-editor-textarea"
                    value={search.query}
                    onChange={(e) => handleChange(search.id, "query", e.target.value)}
                  />
                ) : (
                  search.query
                )}
              </td>
              <td>
                {editing === search.id ? (
                  <input
                    className="savedsearches-editor-input-text"
                    type="text"
                    value={search.label || ""}
                    onChange={(e) => handleChange(search.id, "label", e.target.value)}
                  />
                ) : (
                  search.label
                )}
              </td>
              <td>
                {editing === search.id ? (
                  <input
                    className="savedsearches-editor-input-number"
                    type="number"
                    value={search.weight}
                    onChange={(e) => handleChange(search.id, "weight", e.target.value)}
                  />
                ) : (
                  search.weight
                )}
              </td>
              <td>
                {editing === search.id ? (
                  <>
                    <button
                      className="savedsearches-editor-button"
                      onClick={() => handleSave(search)}
                    >
                      Save
                    </button>
                    <button
                      className="savedsearches-editor-button"
                      onClick={() => setEditing(null)}
                    >
                      Cancel
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      className="savedsearches-editor-button"
                      onClick={() => setEditing(search.id)}
                    >
                      Edit
                    </button>
                    <button
                      className="savedsearches-delete-button"
                      onClick={() => handleDelete(search.id)}
                    >
                      Delete
                    </button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
